var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyFilters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 106,
    viewBox: "0 0 280 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_72148)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M154.571 104.903C112.837 91.9267 150.718 68.7988 126.622 56.2046C102.527 43.6104 37.0103 58.1696 61.9881 25.4591C91.3238 -12.9626 219.795 -7.62225 247.494 39.5004C275.193 86.6231 196.305 117.879 154.571 104.903Z",
    fill: "url(#paint0_linear_762_72148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5835 43.0923C72.8963 43.0923 74.2091 44.0103 74.7342 45.2954C75.2593 46.6724 75.0843 48.1411 74.1216 49.2427L65.2822 59.6157V75.4048C65.2822 76.5981 64.6696 77.6079 63.7069 78.0669C62.7442 78.5259 61.6064 78.4341 60.7313 77.7915L55.1301 73.3852C54.4299 72.8345 54.0799 72.0083 54.0799 70.9985V59.6157L45.153 49.2427C44.1903 48.1411 44.0153 46.6724 44.5404 45.2954C45.0655 44.0103 46.3782 43.0923 47.691 43.0923H71.5835Z",
    fill: "#8C9AE6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.245,
    cy: 34.8266,
    rx: 5.14157,
    ry: 5.14157,
    fill: "#B2BBEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.2292,
    cy: 32.0586,
    r: 3.55955,
    fill: "#8C9AE6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.3416,
    cy: 20.9843,
    rx: 7.51461,
    ry: 7.51461,
    fill: "#6578DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.955 14.5471C145.955 13.9537 146.436 13.4727 147.03 13.4727H148.252C148.845 13.4727 149.326 13.9537 149.326 14.5471V39.3645C149.326 39.9579 148.845 40.4389 148.252 40.4389H147.03C146.436 40.4389 145.955 39.9579 145.955 39.3645V14.5471Z",
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.287 28.03C138.287 27.4366 138.768 26.9556 139.361 26.9556H140.583C141.176 26.9556 141.657 27.4366 141.657 28.03V39.3643C141.657 39.9577 141.176 40.4387 140.583 40.4387H139.361C138.768 40.4387 138.287 39.9577 138.287 39.3643V28.03Z",
    fill: "#6578DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.618 17.9177C130.618 17.3243 131.099 16.8433 131.692 16.8433H132.914C133.508 16.8433 133.989 17.3243 133.989 17.9177V39.3643C133.989 39.9577 133.508 40.4388 132.914 40.4388H131.692C131.099 40.4388 130.618 39.9577 130.618 39.3643V17.9177Z",
    fill: "#8C9AE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.949 31.4011C122.949 30.8077 123.431 30.3267 124.024 30.3267H125.246C125.839 30.3267 126.32 30.8077 126.32 31.4011V39.3646C126.32 39.958 125.839 40.439 125.246 40.439H124.024C123.431 40.439 122.949 39.958 122.949 39.3646V31.4011Z",
    fill: "#B2BBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.281 38.1423C115.281 37.5489 115.762 37.0679 116.355 37.0679H117.577C118.171 37.0679 118.652 37.5489 118.652 38.1423V39.3642C118.652 39.9576 118.171 40.4387 117.577 40.4387H116.355C115.762 40.4387 115.281 39.9576 115.281 39.3642V38.1423Z",
    fill: "#F0F3FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_762_72148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.104,
    y: 16.4019,
    width: 49.2535,
    height: 21.1084,
    rx: 2.14302,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.76,
    y: 23.3843,
    width: 7.14339,
    height: 7.14339,
    rx: 3.57169,
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.341,
    y: 22.4961,
    width: 18.2822,
    height: 2.43763,
    rx: 1.21882,
    fill: "#B2BBEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.341,
    y: 27.3711,
    width: 32.3596,
    height: 4.04494,
    rx: 2.02247,
    fill: "#6578DE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.618 40.439C248.285 40.439 250.892 39.6482 253.109 38.1666C255.326 36.6851 257.054 34.5793 258.075 32.1156C259.095 29.6519 259.362 26.9409 258.842 24.3254C258.322 21.7099 257.038 19.3074 255.152 17.4218L252.482 20.0913C253.84 21.449 254.765 23.1788 255.139 25.0619C255.514 26.9451 255.322 28.897 254.587 30.6709C253.852 32.4447 252.608 33.9609 251.011 35.0276C249.415 36.0943 247.538 36.6637 245.618 36.6637V40.439Z",
    fill: "#1E38BE",
    stroke: "white",
    strokeWidth: 0.674157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.618 13.4727C243.251 13.4727 240.926 14.0957 238.876 15.2791L240.764 18.5486C242.24 17.6965 243.914 17.248 245.618 17.248L245.618 13.4727Z",
    fill: "#6578DE",
    stroke: "white",
    strokeWidth: 0.674157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.876 15.2791C236.827 16.4625 235.125 18.1645 233.941 20.2142C232.758 22.2639 232.135 24.589 232.135 26.9558H235.91C235.91 25.2517 236.359 23.5777 237.211 22.1019C238.063 20.6261 239.288 19.4006 240.764 18.5486L238.876 15.2791Z",
    fill: "#8C9AE6",
    stroke: "white",
    strokeWidth: 0.674157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.135 26.9558C232.135 28.7265 232.484 30.4797 233.161 32.1156C233.839 33.7514 234.832 35.2378 236.084 36.4898L238.753 33.8203C237.852 32.9189 237.137 31.8487 236.649 30.6709C236.161 29.493 235.91 28.2307 235.91 26.9558H232.135Z",
    fill: "#B2BBEE",
    stroke: "white",
    strokeWidth: 0.674157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.084 36.4898C237.336 37.7419 238.822 38.735 240.458 39.4126C242.094 40.0902 243.847 40.439 245.618 40.439V36.6637C244.343 36.6637 243.081 36.4126 241.903 35.9247C240.725 35.4369 239.655 34.7218 238.753 33.8203L236.084 36.4898Z",
    fill: "#F0F3FF",
    stroke: "white",
    strokeWidth: 0.674157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.152 17.4218C252.623 14.8932 249.194 13.4727 245.618 13.4727V17.248C248.193 17.248 250.662 18.2707 252.482 20.0913L255.152 17.4218Z",
    fill: "#465DD8",
    stroke: "white",
    strokeWidth: 0.674157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.046 71.873C120.849 71.9222 120.729 72.122 120.779 72.3192C120.828 72.5164 121.028 72.6363 121.225 72.587L121.046 71.873ZM135.855 74.8059L135.624 74.5197L135.855 74.8059ZM146.424 76.5433L146.084 76.684L146.424 76.5433ZM168.607 74.0699L168.434 73.7452L168.607 74.0699ZM178.746 62.0553L179.077 62.2168L178.746 62.0553ZM239.999 70.758L240.054 71.1217L239.999 70.758ZM121.225 72.587C122.975 72.1495 124.288 72.4197 125.393 72.9778C126.523 73.5489 127.432 74.4148 128.401 75.2252C129.345 76.0153 130.352 76.7562 131.605 76.89C132.874 77.0254 134.303 76.5331 136.087 75.0922L135.624 74.5197C133.917 75.8987 132.679 76.2644 131.684 76.1581C130.672 76.0502 129.816 75.4495 128.873 74.6607C127.954 73.8921 126.953 72.9415 125.724 72.3209C124.47 71.6872 122.976 71.3904 121.046 71.873L121.225 72.587ZM136.087 75.0922C137.409 74.0243 138.56 73.2535 139.575 72.7804C140.59 72.3075 141.445 72.1434 142.187 72.254C143.652 72.472 144.892 73.8027 146.084 76.684L146.764 76.4025C145.562 73.4986 144.184 71.8071 142.296 71.526C141.362 71.387 140.357 71.6042 139.264 72.1133C138.172 72.6222 136.968 73.4341 135.624 74.5197L136.087 75.0922ZM146.084 76.684C146.864 78.5673 147.708 80.3788 148.644 81.9256C149.577 83.4689 150.616 84.7724 151.795 85.6167C152.985 86.4688 154.323 86.8546 155.813 86.5419C157.288 86.2327 158.863 85.2504 160.569 83.4742L160.039 82.9644C158.386 84.6851 156.935 85.5547 155.662 85.8216C154.406 86.0851 153.276 85.7715 152.224 85.0183C151.161 84.2571 150.184 83.0492 149.273 81.5446C148.365 80.0435 147.538 78.2705 146.764 76.4025L146.084 76.684ZM160.569 83.4742C163.957 79.9474 164.715 78.3432 165.295 77.2649C165.571 76.7508 165.788 76.3966 166.244 75.9943C166.714 75.5794 167.448 75.105 168.78 74.3946L168.434 73.7452C167.094 74.4599 166.295 74.9674 165.757 75.4425C165.204 75.93 164.938 76.3736 164.647 76.9164C164.09 77.9518 163.369 79.4973 160.039 82.9644L160.569 83.4742ZM168.78 74.3946C174.41 71.392 176.487 67.5212 179.077 62.2168L178.415 61.8939C175.835 67.179 173.844 70.86 168.434 73.7452L168.78 74.3946ZM179.077 62.2168C180.736 58.8188 184.5 57.0181 188.621 56.9871C192.736 56.956 197.13 58.696 199.966 62.2835L200.544 61.8271C197.549 58.0391 192.927 56.2186 188.615 56.2511C184.308 56.2836 180.233 58.1707 178.415 61.8939L179.077 62.2168ZM199.966 62.2835C202.931 66.0335 205.9 67.355 208.868 66.95C211.793 66.5511 214.607 64.4864 217.312 61.7413L216.788 61.2248C214.105 63.9476 211.438 65.8567 208.769 66.2208C206.145 66.5788 203.41 65.4524 200.544 61.8271L199.966 62.2835ZM217.312 61.7413C218.605 60.4288 219.67 60.1536 220.568 60.37C221.507 60.5962 222.386 61.3837 223.231 62.4759C224.069 63.5602 224.821 64.8713 225.539 66.0622C225.895 66.6523 226.243 67.2136 226.585 67.689C226.923 68.1605 227.271 68.5716 227.633 68.844L228.076 68.2559C227.804 68.0515 227.508 67.7133 227.182 67.2598C226.86 66.8103 226.525 66.2711 226.17 65.6821C225.466 64.5148 224.685 63.1531 223.813 62.0256C222.947 60.906 221.936 59.9426 220.74 59.6545C219.504 59.3565 218.188 59.8033 216.788 61.2248L217.312 61.7413ZM227.633 68.844C230.271 70.8287 235.289 71.8507 240.054 71.1217L239.943 70.3942C235.307 71.1035 230.508 70.0861 228.076 68.2559L227.633 68.844ZM240.054 71.1217C242.998 70.6714 245.708 70.2472 247.96 70.4147C250.191 70.5807 251.899 71.3215 252.926 73.1464L253.567 72.7855C252.376 70.6684 250.388 69.8572 248.014 69.6807C245.661 69.5057 242.856 69.9485 239.943 70.3942L240.054 71.1217Z",
    fill: "#465DD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_762_72148",
    x: 164.755,
    y: 15.0535,
    width: 51.9501,
    height: 25.1533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.674157
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.368627 0 0 0 0 0.415686 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_762_72148"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.34831
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.674157
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.368627 0 0 0 0 0.415686 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_762_72148",
    result: "effect2_dropShadow_762_72148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_762_72148",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_762_72148",
    x1: 154.831,
    y1: 2.68595,
    x2: 154.831,
    y2: 122.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_72148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 105.169,
    rx: 5.39326,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilters);
export default __webpack_public_path__ + "static/media/EmptyFilters.199276be.svg";
export { ForwardRef as ReactComponent };